import { FC, useState } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

type GenerateCertificateTableDownloadButtonProps = {
  generate: () => Promise<void>;
};

const GenerateCertificateTableDownloadButton: FC<
  GenerateCertificateTableDownloadButtonProps
> = ({ generate }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      await generate();
    } catch {
      /* generation utilities may log errors */
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-icon btn-trigger"
        onClick={handleClick}
      >
        <em className="icon ni ni-file-download" />
      </button>
      {isLoading && <CustomLoading />}
    </>
  );
};

export default GenerateCertificateTableDownloadButton;
